import HTTP from './axios';

const PoweredByService = {
  one: id => HTTP.get(`/themes/${id}`).then(response => response.data.data),
  all: () => HTTP.get('/themes').then(response => response.data.data),
  getTheme: companyId => HTTP.get(`/themes/load/${companyId}`).then(response => response.data.data),
  create: theme => HTTP.post('/themes', theme).then(response => response.data.data),
  update: theme => HTTP.put('/themes', theme).then(response => response.data.data),
  remove: id => HTTP.put(`/themes/${id}`).then(response => response.data.data),
  saveImage: (id, base64Image, type) => HTTP.post(`/themes/${id}/img`, { base64Image, type }).then(response => response.data.data),
};

export default PoweredByService;
